import { render, staticRenderFns } from "./ButtonGroupButton.vue?vue&type=template&id=589ae116&scoped=true&"
import script from "./ButtonGroupButton.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupButton.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGroupButton.vue?vue&type=style&index=0&id=589ae116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ae116",
  null
  
)

export default component.exports